###*
  * Allows to request report as JSON object or Excel file
  * Callback can be used to render received JSON
###

class INTENT.report.DataManager

  constructor: (@controller) ->
    @url_load = '/livereports/get_bigdata'
    @url_download = '/livereports/excel'
    @request = null
    @jobId = null
    @cancelRequests = []
    @cancelSupport = @controller.get_dataset(@controller.get_dataset_code()).cancel_support || no
    @cancelPressed = false

    @init_events()

  show_api_link: (link) =>
    btn = $('#api_link')
    $('.api_link_btn').each((id, e) ->
      self = $(e)
      url = link[self.data 'format'] || ''
      self.off 'click'
      self.on 'click', (e) =>
        e.preventDefault()
        try
          el = document.createElement('textarea')
          el.value = url
          el.setAttribute('readonly', '')
          el.style.position = 'absolute'
          el.style.left = '-9999px';
          document.body.appendChild(el)
          el.select();
          document.execCommand('copy')
          document.body.removeChild(el)
          INTENT.utils.Notify.success __('report.api_link.copy.success')
        catch err
          INTENT.utils.Notify.error __('report.api_link.copy.error')
      self.find('a').attr('href', url)
    )
    btn.removeClass 'hidden'
    return

  prepare_filters: (settings) =>
    @cancelSupport = @controller.get_dataset(@controller.get_dataset_code()).cancel_support || no
    filters = settings.filters
    settings.filters = []
    settings.having = []
    filters.map (item) =>
      if _.isArray item.values
        settings.filters.push item
      else
        settings.having.push item
    return settings

  unregister_unload_handlers: =>
    window.onbeforeunload = ->
    window.onblur = ->

  register_unload_handlers: =>
    window.onbeforeunload = =>
      if @isRunning and @jobId
        @cancel_running_job()
      __ 'report_will_be_cancelled'
    window.onblur = =>
      if @isRunning and @jobId
        @cancel_running_job()
      __ 'report_will_be_cancelled'

  load_report: (settings, callback) =>
    self = @
    @cancelPressed = false
    performRequest = (settings, callback) =>
      self.request = $.ajax
        url: @url_load
        method: 'post'
        data:
          query: settings
        dataType: 'json'
        beforeSend: () =>
          @register_unload_handlers()
        complete: (xhr) =>
          @abortJobReqs()
          @unregister_unload_handlers()
          Loader.hide()
          @request = null
        success: (response) =>
          if _.isObject response
            if response.data and response.data.api_link
              @show_api_link response.data.api_link
            if _.isFunction callback
              callback response
    # if cancel is not supported
    if not @cancelSupport
      Loader.show buttons: ['cancel']
      performRequest settings, callback
      return
    # if cancel is supported
    Loader.show()
    req = $.ajax({url: '/ajax/v2/report/id'}).always (r) =>
      Loader.show buttons: ['cancel']
      @jobId = r.report_id
      settings.report_id = r.report_id
      performRequest @prepare_filters(settings), callback
    @cancelRequests.push req


  download_report: (settings, callback) =>
    self = @
    @cancelPressed = false
    performRequest = (settings, callback) =>
      self.request = $.fileDownload @url_download, {
        httpMethod: 'POST'
        data:
          query: settings

        prepareCallback: (url) =>
          @controller.lock_actions()
          @set_job_id()
          @register_unload_handlers()
          if Cookies.get('fileDownload')?
            Cookies.remove 'fileDownload'

        abortCallback: (url) =>
          @controller.unlock_actions()
          @abortJobReqs()
          Loader.hide()
          @request = null

        failCallback: (html, url) =>
          @controller.unlock_actions()
          @request = null
          @abortJobReqs()
          Loader.hide()
          if  !@cancelPressed
            INTENT.utils.Notify.error __('livereport.error.occurred')

        successCallback: (url) =>
          @controller.unlock_actions()
          @unregister_unload_handlers()
          @request = null
          @abortJobReqs()
          Loader.hide()
          if _.isFunction callback
            callback response
      }
    # if cancel is not supported
    if not @cancelSupport
      Loader.show buttons: ['cancel']
      performRequest @prepare_filters(settings), callback
      return
    # if cancel is supported
    Loader.show()
    $.ajax({url: '/ajax/v2/report/id'}).always (r) =>
      Loader.show buttons: ['cancel']
      @jobId = r.report_id
      settings.report_id = r.report_id
      performRequest @prepare_filters(settings), callback

  init_events: () =>
    $(document).on 'click', '[data-fullpage-loader-action="cancel"]', () =>
      if @request? and _.isFunction @request.abort
        @request.abort()
        @cancel_running_job()
      else
        Loader.hide()


  set_job_id: (callback) =>
    return;

  cancel_running_job: () =>
    if not @cancelSupport
      return
    if @jobId
      req = $.ajax({
        url: '/ajax/v2/report/cancel'
        method: 'post'
        data:
          report_id: @jobId
      })
      Cookies.set('fileDownload', 1)
      @controller.unlock_actions()
      window.onbeforeunload = null;
      @cancelPressed = true
      @cancelRequests.push req

  abortJobReqs: () =>
    if not @cancelSupport
      return
    @cancelRequests.forEach (req) ->
      req.abort()
    @cancelRequests = [];
